var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7071 9.04011C22.0976 8.64959 22.0976 8.01643 21.7071 7.6259L15.3431 1.26194C14.9526 0.871416 14.3195 0.871416 13.9289 1.26194C13.5384 1.65246 13.5384 2.28563 13.9289 2.67615L19.5858 8.33301L13.9289 13.9899C13.5384 14.3804 13.5384 15.0136 13.9289 15.4041C14.3195 15.7946 14.9526 15.7946 15.3431 15.4041L21.7071 9.04011ZM0 9.33301H21V7.33301H0V9.33301Z",
    fill: "#2191F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrow-blue.225d32961311e1ff5fc440b558dc2409.svg";
export { ForwardRef as ReactComponent };